<template>
  <div class="form-group base-input">
    <slot name="label">
      <label :for="id" v-if="label" :class="labelClasses">
        {{ label }}
        <span v-if="required">*</span>
      </label>
    </slot>

    <input
      v-if="mask"
      :id="id"
      :value="value"
      v-on="listeners"
      v-mask="mask"
      :masked="masked"
      :type="type"
      :class="[{ valid: valid }, inputClasses]"
      :placeholder="placeholder"
      :autocomplete="autocomplete ? 'on' : 'off'"
    />

    <input
      v-else-if="min"
      :id="id"
      :type="type"
      v-on="listeners"
      :class="[{ valid: valid }, inputClasses]"
      :value="value"
      :min="min"
      :max="max"
      :placeholder="placeholder"
      :autocomplete="autocomplete ? 'on' : 'off'"
    />

    <input
      v-else
      :id="id"
      :type="type"
      v-on="listeners"
      :class="[{ valid: valid }, inputClasses]"
      :value="value"
      :placeholder="placeholder"
      :autocomplete="autocomplete ? 'on' : 'off'"
    />
  </div>
</template>

<script>
import { mask, masked } from 'vue-the-mask';

export default {
  directives: { mask, masked },
  name: 'base-input',

  inheritAttrs: false,

  data: () => ({
    focused: false,
  }),

  props: {
    id: {
      type: String,
      required: true,
      description: 'ID of the input so we can create a label for that input',
    },

    autocomplete: {
      type: Boolean,
      required: false,
      default: false,
      description: 'autocomplete attribute of the input tag(HTML 5 tag)',
    },

    label: {
      type: String,
      required: false,
      description: 'Label that goes above the input',
    },

    labelClasses: {
      type: Array,
      required: false,
      description: 'Label classes',
    },

    inputClasses: {
      type: Array,
      required: false,
      description: 'Input classes',
    },

    placeholder: {
      type: String,
      required: false,
      default: '',
      description: 'Input placeholder',
    },

    type: {
      type: String,
      required: false,
      default: 'text',
      description: 'Input type',
    },

    value: {
      type: [String, Number],
      description: 'Input value',
      default: '',
    },

    required: {
      type: Boolean,
      required: false,
      default: false,
      description: 'Is this input required? If so we will add a * after the label',
    },

    mask: {
      type: [String, Array],
      description: 'Mask that the input will have',
    },

    masked: {
      type: Boolean,
      default: false,
      description: 'Boolean that will say if the value of the input will be saved masked or not',
    },

    valid: {
      type: Boolean,
      default: false,
      description: 'Boolean that we will use to check if the input is now valid',
    },

    min: {
      type: String,
      default: '1900-01-01',
      description: 'The min date',
    },

    max: {
      type: String,
      default: '',
      description: 'The max date',
    },
  },

  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: this.updateValue,
        focus: this.onFocus,
      };
    },
  },

  methods: {
    updateValue(event) {
      // let value = event.target.value;
      // this.$emit('input', value);
      let value =
        event.target.value && !this.masked && this.mask ? event.target.value.replace(/\D/g, '') : event.target.value;
      this.$emit('input', value);
    },

    onFocus(value) {
      this.focused = true;
      this.$emit('focus', value);
    },
  },
};
</script>

<style></style>
